import React, { useEffect, useMemo } from "react";
import {
  GEOFENCE_ELEMENTS,
  MASSIVE_LIST_ELEMENTS,
  PROCESS_RELATIONSHIP,
  USERS_MOBILE,
} from "./gql/Queries";
import { useQuery } from "react-apollo-hooks";
import useGlobal from "../../store";
import { useLazyQuery, useMutation } from "react-apollo";
import { PROCESS_RELATIONSHIP_ACTION, PROCESS_RELATIONSHIP_ELEMENT_TYPES } from "../../constants";
import UsersAssginedView from "../../Views/ProcessRelationship/UsersAssginedView";
import { UPDATE_PROCESS_RELATIONSHIP_USERS } from "./gql/Mutations";
import history from "../../utils/history";
import LoadingCircleView from "../../Views/LoadingCircleView";
import auth from "../../utils/auth";

const UserAssigned = (props) => {
  const { match } = props;
  const { params } = match;
  const { id } = params;

  const [session, globalActions] = useGlobal(
    (state) => state.session,
    (actions) => actions
  );

  const {
    data: processRelationship,
    loading: loadingProcessRelationship,
    error: errorProcessRelatiuonship,
    //refetch,
  } = useQuery(PROCESS_RELATIONSHIP, {
    variables: {
      _id: id,
      action: PROCESS_RELATIONSHIP_ACTION.VIEW_USERS_ASSIGNED,
      session: auth.getUserSessionData(session),
    },
    fetchPolicy: "network-only",
  });

  const {
    data: usersMobile,
    loading: loadingusersMobile,
    error: errorusersMobile,
    //refetch,
  } = useQuery(USERS_MOBILE, {
    variables: {
      app: session.user ? session.appRef._id : "",
    },
    fetchPolicy: "network-only",
  });

  const [
    getMassiveListItems,
    {
      data: massiveListItems,
      loading: loadingMassiveListItems,
      error: errorMassiveListItems,
    },
  ] = useLazyQuery(MASSIVE_LIST_ELEMENTS);

  const [
    getGeofenceGroupItems,
    {
      data: geofenceGroupItems,
      loading: loadingGeofenceGroupItems,
      error: errorGeofenceGroupItems,
    },
  ] = useLazyQuery(GEOFENCE_ELEMENTS);

  useEffect(() => {

    const { getProcessRelationship } = processRelationship;

    if (
      !loadingProcessRelationship &&
      getProcessRelationship &&
      getProcessRelationship?.elementsList?.length
    ) {
      const { elementsList, elementsType } = getProcessRelationship;

      if (elementsType === PROCESS_RELATIONSHIP_ELEMENT_TYPES.MASSIVE_LIST) {
        getMassiveListItems({
          variables: {
            massiveList: elementsList[0],
          },
        });
      } else if (
        elementsType === PROCESS_RELATIONSHIP_ELEMENT_TYPES.GEOFENCES
      ) {

        getGeofenceGroupItems({
          variables: {
            groupIds: elementsList,
            app: session.user ? session.appRef._id : "",
            archived: false
          },
        });
      }
    }
  }, [loadingProcessRelationship]);

  const assignedUsers = useMemo(() => {
    const { getProcessRelationship } = processRelationship;

    if (
      !loadingProcessRelationship &&
      getProcessRelationship &&
      getProcessRelationship?.assignedUserInfo
    ) {
      const relations =
        getProcessRelationship?.assignedUserInfo?.relations || [];

      return relations;
    }

    return [];
  }, [loadingProcessRelationship]);

  const elementList = useMemo(() => {
    const { getProcessRelationship } = processRelationship;
    if(getProcessRelationship?.elementsType === PROCESS_RELATIONSHIP_ELEMENT_TYPES.MASSIVE_LIST) {
      return massiveListItems?.massiveListItems || [];
    } else {
      return geofenceGroupItems?.geofences.map(geofence => ({
        ...geofence,
        value: geofence.name,
      })) || [];
    }
  }, [massiveListItems, geofenceGroupItems, processRelationship]);

  const usersMobileList = useMemo(() => usersMobile?.userMobiles || [], [usersMobile]);

  const [updateProcessRelationship, { loading: loadingSaveUsers }] = useMutation(
    UPDATE_PROCESS_RELATIONSHIP_USERS,
    {
      onCompleted: (mutationData) => {
        if (mutationData) {
          globalActions.notification.openNotification("tr", {
            message: "Usuarios actualizados correctamente",
            color: "success",
          });
          history.push("/objects");
        }
      },
      onError: (error) => {
        globalActions.notification.openNotification("tr", {
          message: "Error al guardar los usuarios",
          color: "error",
        });
      },
    }
  );

  if (loadingSaveUsers) {
    return <LoadingCircleView />;
  } else {
    return (
      <UsersAssginedView
        processRelationshipName={
          processRelationship?.getProcessRelationship?.name || ""
        }
        loadingElements={loadingMassiveListItems || loadingGeofenceGroupItems}
        elementsList={elementList}
        usersMobile={usersMobileList}
        assignedUsers={assignedUsers}
        saveUseersAssigned={(values) => {
          const { getProcessRelationship } = processRelationship;

          const assignedUsers = getProcessRelationship?.assignedUserInfo;
          updateProcessRelationship({
            variables: {
              data: {
                assignedUserInfo: {
                  label: assignedUsers?.label || "",
                  relations: values.relations
                  .map((relation) => ({
                    userId: relation.userId,
                    elementId: relation.elementId,
                    tags: relation.tags,
                  }))
                  .filter((relation) => !!relation.userId),
                }
              },
              where: {
                _id: getProcessRelationship?._id,
                session: auth.getUserSessionData(session)
              }
            },
          });
        }}
      />
    );
  }

};

export default UserAssigned;
